// @flow

import Request from '@insolus/request';

import type { Ad } from './ads';
import type { RequestPromise } from '@insolus/request';
import type { AllPaginateParams, PaginatedResult } from 'stores/api/_types';

export type Bookmark = {|
    id: number,
    advertiserId: number,
    ad: Ad
|};

// ------------------------------------------------------
// -
// -    Functions
// -
// ------------------------------------------------------

const all = (
    advertiserId: number,
    params?: $Shape<AllPaginateParams> = {}
): RequestPromise<PaginatedResult<Bookmark[]>> => (
    Request.get(`/members/${advertiserId}/bookmarks`, { params })
);

const get = (
    advertiserId: number,
    adId: number
): RequestPromise<Bookmark> => Request.get(`/members/${advertiserId}/bookmarks/${adId}`);

const add = (
    advertiserId: number,
    adId: number
): RequestPromise<Bookmark> => (
    Request.post(`/members/${advertiserId}/bookmarks/${adId}`)
);

const remove = (id: number): RequestPromise<void> => (
    Request.delete(`/bookmarks/${id}`)
);

export default { all, add, remove, get };
